import React from 'react';
import { useAppSelector } from '../../app/hooks';

function SkillTrainerFooter() {
  const level = useAppSelector(state => state.skillTrainer.level);
  const pracs = useAppSelector(state => state.skillTrainer.pracs);
  const remainderPracs = useAppSelector(state => state.skillTrainer.remainderPracs);
  
  return (
    <div className="weave-trainer-footer mt-3">
      <div className="d-flex flex-wrap justify-content-center">
        <div className="me-3">
          Level Required: <span className="fw-bold">{level}</span>,
        </div>
        <div className="me-3">
          Practices: <span className="fw-bold">{pracs}</span>,
        </div>
        <div className="me-0">
          Remainder: <span className="fw-bold">{remainderPracs}</span>
        </div>
      </div>
    </div>
  );
}

export default SkillTrainerFooter;